import { render, staticRenderFns } from "./InfiniteTable.vue?vue&type=template&id=c6c66f78&scoped=true&"
import script from "./InfiniteTable.vue?vue&type=script&lang=js&"
export * from "./InfiniteTable.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteTable.vue?vue&type=style&index=0&id=c6c66f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c66f78",
  null
  
)

export default component.exports